export class ProcessoArce {
  constructor(
    public scdNumero: number,
    public scdAno: number,
    public especieSigla: string,
    public setorOrigemSigla: string,
    public recaptcha: string
  ) {}
}
